module.exports = __webpack_public_path__ + "static/media/card_b.2e82d0a1.png";